import React from 'react';
import AltIso from 'alt/utils/AltIso';

import SeoActions from '../actions/SeoActions';
import CurrentUserStore from '../stores/CurrentUserStore';
import CurrentUserActions from '../actions/CurrentUserActions';
import NotificationSettingActions from '../actions/NotificationSettingActions';
import CompanyActions from '../actions/CompanyActions';
import BillingDetailsActions from '../actions/BillingDetailsActions';
import SettingsHeader from '../components/SettingsHeader';
import SettingsGeneral from '../components/SettingsGeneral';
import SettingsBilling from '../components/SettingsBilling';
import SettingsNotifications from '../components/SettingsNotifications';
import SettingsProfile from '../components/SettingsProfile';
import ProProfile from '../components/ProProfile';

import connectToStores from 'alt/utils/connectToStores';
import withRouter from '../utils/with-router';
import doRedirect from '../utils/doRedirect';

@AltIso.define((props) => {
    return SeoActions.pushTitle('Settings');
})

@connectToStores
@withRouter
class Settings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: parseInt(props.params.selectedTab) || 1
        };

        CurrentUserStore.getCurrentUser()
    }

    componentDidMount() {
        if (this.props.user.profile.profile.role === "pro" && !this.props.user.profile.profile.is_candidate) {
            doRedirect(this.context.router, 'completeprofile');
        }
    }

    // 04.02.16 Currently commented out, cause I couldn't find any use for it. - Kevin
    /*componentWillReceiveProps(nextProps) {
        if (nextProps.params.selectedTab !== this.state.activeTab) {
            this.setState({activeTab: parseInt(nextProps.params.selectedTab)});
        }
    }*/

    componentWillUnmount() {
        CurrentUserActions.clearUserDataReceived();
        CompanyActions.clearCompanyData();
        BillingDetailsActions.clearBillingDetailsData();
        NotificationSettingActions.clearNotificationSettingLoaded();
    }

    static getPropsFromStores() {
        return {
            userStore: CurrentUserStore.getState()
        };
    }

    static getStores() {
        return [CurrentUserStore];
    }

    tabClick(i) {
        this.setState({
            activeTab: i
        });
    }

    render() {
        const user = this.props.userStore;

        let tabContents, tabs;

        if ( user.profile.profile.role == "pro" ) {
            tabs = (
                <div className="tabs">
                    <button onClick={this.tabClick.bind(this, 1)} className={"tab" + (this.state.activeTab === 1 ? " active" : "")}><span>Account settings</span></button>
                    <button onClick={this.tabClick.bind(this, 2)} className={"tab" + (this.state.activeTab === 2 ? " active" : "")}><span>Notifications</span></button>
                </div>
            );
            tabContents = (
                <div className="tab-content whitebox">
                    <ProProfile user={user} isActive={(this.state.activeTab === 1)} />
                    <SettingsNotifications user={user} isActive={(this.state.activeTab === 2)} />
                </div>
            );
        } else {
            tabs = (
                <div className="tabs">
                    <button onClick={this.tabClick.bind(this, 1)} className={"tab" + (this.state.activeTab === 1 ? " active" : "")}><span>Account settings</span></button>
                    {/*<button onClick={this.tabClick.bind(this, 2)} className={"tab" + (this.state.activeTab === 2 ? " active" : "")}><span>Billing</span></button>*/}
                    <button onClick={this.tabClick.bind(this, 3)} className={"tab" + (this.state.activeTab === 3 ? " active" : "")}><span>Notifications</span></button>
                    <button onClick={this.tabClick.bind(this, 4)} className={"tab" + (this.state.activeTab === 4 ? " active" : "")}><span>Your profile</span></button>
                </div>
            );
            tabContents = (
                <div className="tab-content whitebox">
                    <SettingsGeneral isActive={(this.state.activeTab === 1)} />
                    <SettingsBilling isActive={(this.state.activeTab === 2)} />
                    <SettingsNotifications user={user} isActive={(this.state.activeTab === 3)} />
                    <SettingsProfile saveError={this.props.userStore.saveError} user={user} isActive={(this.state.activeTab === 4)} />
                </div>
            );
        }

        return (
            <div className="view-settings">
                <SettingsHeader />

                <div className="view-content maxwidth-wrapper">
                    {tabs}
                    {tabContents}
                </div>
            </div>
        );
    }
}
export default Settings;



/** WEBPACK FOOTER **
 ** ./app/src/views/Settings.js
 **/